/**
 * Which programmes the reports cover, so a short or empty report reads as
 * what it is: the whole tenant, or only what the caller may open.
 *
 * @module components/reports/ReportScopeNotice
 */

import React from "react";

import { countLabel } from "@/components/ui";
import { useReportScope } from "@/reports/ReportTenantScope";

function tenantWide(count: number, tenant: string): string {
  if (count === 0) {
    return `No programmes in ${tenant} yet.`;
  }
  return count === 1 ? `The one programme in ${tenant}.` : `All ${count} programmes in ${tenant}.`;
}

export function ReportScopeNotice(): React.ReactElement {
  const { tenantName, scope, status, programmes } = useReportScope();
  const tenant = tenantName ?? "this tenant";

  if (status !== "ready") {
    return <span data-testid="report-scope-notice">Governed curriculum for {tenant}.</span>;
  }

  const count = programmes.length;
  const text =
    scope === "tenant"
      ? tenantWide(count, tenant)
      : `${count === 0 ? "No programmes" : countLabel(count, "programme")} you can open in ${tenant}.`;
  return (
    <span data-testid="report-scope-notice" data-scope={scope}>
      {text}
    </span>
  );
}
